import { ElementsSDK } from '@yiluhub/ui-sdk-react';

import { FareType } from 'modules/eurail/utils/types';

import { getLocalizedLocationData } from './locationData';

export const getFareOption = (
  fareType: FareType,
  fareOptions: ElementsSDK.SelectOption[],
): ElementsSDK.SelectOption | undefined => {
  return fareOptions.find((option) => option.value === fareType);
};

export const getLocationOption = (
  location: string | undefined,
  lang: string = 'en',
): ElementsSDK.SelectOption | undefined => {
  const localizedData = getLocalizedLocationData(lang);
  return localizedData.find((option) => option.value === location);
};

type LocationList = { value: string; label: string };

export const reorderLocations = (locationList: LocationList[], priorityList?: string) => {
  const priorities = priorityList ? priorityList.split(',').map((p) => p.trim()) : [];

  const prioritySet = new Set(priorities);

  const priorityItems = priorities
    .map((code) => locationList.find((loc) => loc.value === code))
    .filter((loc): loc is LocationList => Boolean(loc));

  const otherItems = locationList.filter((loc) => !prioritySet.has(loc.value));

  return [...priorityItems, ...otherItems];
};
